// This file is auto-generated by @hey-api/openapi-ts

import type { Options } from '@hey-api/client-axios'
import {
  type DefaultError,
  type InfiniteData,
  infiniteQueryOptions,
  queryOptions,
  type UseMutationOptions,
} from '@tanstack/react-query'
import type { AxiosError } from 'axios'

import {
  activateAccount,
  addExpertReview,
  addProjectEval,
  addProjectQueryLogGroupRanks,
  addUserFeedback,
  checkCleanlabAdmin,
  client,
  consultAiGuidance,
  copyProjectSettings,
  createAccessKey,
  createAiGuidance,
  createClassification,
  createClassificationOption,
  createDeterministicEval,
  createDeterministicGuardrail,
  createExpertAnswer,
  createExpertReview,
  createManagedOrganization,
  createOrganizationSetupIntent,
  createProject,
  createProjectFromTemplate,
  createPromptRecommendation,
  createRemediation,
  deleteAccessKey,
  deleteAiGuidance,
  deleteClassification,
  deleteClassificationOption,
  deleteDeterministicEval,
  deleteDeterministicGuardrail,
  deleteExpertAnswer,
  deleteExpertReview,
  deleteProject,
  deleteQueryLog,
  deleteRemediation,
  deleteUser,
  detectQuery,
  editAnswer,
  editDraftAnswer,
  editDraftExpertAnswer,
  editDraftGuidance,
  editExpertAnswer,
  editGuidance,
  exportProject,
  exportProjectToS3,
  exportQueryLogGroupsToS3,
  generateRegex,
  getAccessKey,
  getAiGuidance,
  getAllIndividualOrganizations,
  getAllManagedOrganizations,
  getClassification,
  getClassificationOption,
  getClassificationsDisplay,
  getClusteringStatusAdmin,
  getConversationHistory,
  getCurrentPrompt,
  getDeterministicEval,
  getDeterministicGuardrail,
  getExpertAnswer,
  getExpertAnswerWithResolvedLogsCount,
  getExpertReview,
  getMetrics,
  getMyself,
  getMyselfFromApiKey,
  getOrganization,
  getOrganizationAsAdmin,
  getOrganizationCardDetails,
  getOrganizationInvoices,
  getOrganizationMembers,
  getOrganizationMembersPublic,
  getOrganizationPlanDetails,
  getOrganizationUsage,
  getProject,
  getProjectAnalytics,
  getProjectEvals,
  getProjectGuardrails,
  getProjectGuardrailsNext,
  getProjectIdFromAccessKey,
  getProjectWithUnaddressedCounts,
  getQueryLog,
  getRemediation,
  getRemediationWithResolvedLogsCount,
  getTlmExplanation,
  getUserOrganizationPermissions,
  getUserOrganizations,
  getUsers,
  inviteSme,
  listAiGuidance,
  listAppliedToLogs,
  listClassificationOptions,
  listClassifications,
  listDeterministicGuardrails,
  listExpertAnswers,
  listExpertReviewAppliedToLogs,
  listExpertReviews,
  listIssues,
  listLogsByIssue,
  listProjectAccessKeys,
  listProjects,
  listProjectsAdmin,
  listQueryLogGroups,
  listQueryLogs,
  listQueryLogsByGroup,
  listRemediations,
  listResolvedLogs,
  patchDeterministicEvalFallbackPriority,
  patchDeterministicGuardrailFallbackPriority,
  patchProjectEvalGuardrailedFallbackPriority,
  pauseExpertAnswer,
  pauseRemediation,
  publishExpertAnswer,
  publishGuidance,
  publishRemediation,
  refreshApiKey,
  removeExpertReview,
  removeProjectEval,
  resendVerificationEmail,
  revokeAccessKey,
  runQueryLogClusteringAdmin,
  sendGuardrailNotificationManualProject,
  sendOutdatedRemediationsNotificationManualProject,
  startRemediation,
  switchUserOrganization,
  tlmChat,
  tlmHealthCheck,
  unpauseExpertAnswer,
  unpauseRemediation,
  updateAccessKey,
  updateClassification,
  updateClassificationOption,
  updateDeterministicEval,
  updateDeterministicGuardrail,
  updateExpertReview,
  updateIssueReviewStatus,
  updateMetadata,
  updateOrganization,
  updateOrganizationMemberRole,
  updateProject,
  updateProjectEval,
  updateProjectTemplateStatus,
  updateRemediationReviewStatus,
  validateQuery,
} from '../sdk.gen'
import type {
  ActivateAccountData,
  ActivateAccountError,
  ActivateAccountResponse,
  AddExpertReviewData,
  AddExpertReviewError,
  AddExpertReviewResponse,
  AddProjectEvalData,
  AddProjectEvalError,
  AddProjectEvalResponse,
  AddProjectQueryLogGroupRanksData,
  AddProjectQueryLogGroupRanksError,
  AddProjectQueryLogGroupRanksResponse,
  AddUserFeedbackData,
  AddUserFeedbackError,
  AddUserFeedbackResponse,
  CheckCleanlabAdminData,
  ConsultAiGuidanceData,
  ConsultAiGuidanceError,
  ConsultAiGuidanceResponse,
  CopyProjectSettingsData,
  CopyProjectSettingsError,
  CopyProjectSettingsResponse,
  CreateAccessKeyData,
  CreateAccessKeyError,
  CreateAccessKeyResponse,
  CreateAiGuidanceData,
  CreateAiGuidanceError,
  CreateAiGuidanceResponse,
  CreateClassificationData,
  CreateClassificationError,
  CreateClassificationOptionData,
  CreateClassificationOptionError,
  CreateClassificationOptionResponse,
  CreateClassificationResponse,
  CreateDeterministicEvalData,
  CreateDeterministicEvalError,
  CreateDeterministicEvalResponse,
  CreateDeterministicGuardrailData,
  CreateDeterministicGuardrailError,
  CreateDeterministicGuardrailResponse,
  CreateExpertAnswerData,
  CreateExpertAnswerError,
  CreateExpertAnswerResponse,
  CreateExpertReviewData,
  CreateExpertReviewError,
  CreateExpertReviewResponse,
  CreateManagedOrganizationData,
  CreateManagedOrganizationError,
  CreateManagedOrganizationResponse,
  CreateOrganizationSetupIntentData,
  CreateOrganizationSetupIntentError,
  CreateOrganizationSetupIntentResponse,
  CreateProjectData,
  CreateProjectError,
  CreateProjectFromTemplateData,
  CreateProjectFromTemplateError,
  CreateProjectFromTemplateResponse,
  CreateProjectResponse,
  CreatePromptRecommendationData,
  CreatePromptRecommendationError,
  CreatePromptRecommendationResponse,
  CreateRemediationData,
  CreateRemediationError,
  CreateRemediationResponse,
  DeleteAccessKeyData,
  DeleteAccessKeyError,
  DeleteAccessKeyResponse,
  DeleteAiGuidanceData,
  DeleteAiGuidanceError,
  DeleteAiGuidanceResponse,
  DeleteClassificationData,
  DeleteClassificationError,
  DeleteClassificationOptionData,
  DeleteClassificationOptionError,
  DeleteClassificationOptionResponse,
  DeleteClassificationResponse,
  DeleteDeterministicEvalData,
  DeleteDeterministicEvalError,
  DeleteDeterministicEvalResponse,
  DeleteDeterministicGuardrailData,
  DeleteDeterministicGuardrailError,
  DeleteDeterministicGuardrailResponse,
  DeleteExpertAnswerData,
  DeleteExpertAnswerError,
  DeleteExpertAnswerResponse,
  DeleteExpertReviewData,
  DeleteExpertReviewError,
  DeleteExpertReviewResponse,
  DeleteProjectData,
  DeleteProjectError,
  DeleteProjectResponse,
  DeleteQueryLogData,
  DeleteQueryLogError,
  DeleteQueryLogResponse,
  DeleteRemediationData,
  DeleteRemediationError,
  DeleteRemediationResponse,
  DeleteUserData,
  DeleteUserError,
  DeleteUserResponse,
  DetectQueryData,
  DetectQueryError,
  DetectQueryResponse,
  EditAnswerData,
  EditAnswerError,
  EditAnswerResponse,
  EditDraftAnswerData,
  EditDraftAnswerError,
  EditDraftAnswerResponse,
  EditDraftExpertAnswerData,
  EditDraftExpertAnswerError,
  EditDraftExpertAnswerResponse,
  EditDraftGuidanceData,
  EditDraftGuidanceError,
  EditDraftGuidanceResponse,
  EditExpertAnswerData,
  EditExpertAnswerError,
  EditExpertAnswerResponse,
  EditGuidanceData,
  EditGuidanceError,
  EditGuidanceResponse,
  ExportProjectData,
  ExportProjectToS3Data,
  ExportProjectToS3Error,
  ExportQueryLogGroupsToS3Data,
  ExportQueryLogGroupsToS3Error,
  GenerateRegexData,
  GenerateRegexError,
  GenerateRegexResponse2,
  GetAccessKeyData,
  GetAiGuidanceData,
  GetAllIndividualOrganizationsData,
  GetAllManagedOrganizationsData,
  GetClassificationData,
  GetClassificationOptionData,
  GetClassificationsDisplayData,
  GetClusteringStatusAdminData,
  GetConversationHistoryData,
  GetCurrentPromptData,
  GetDeterministicEvalData,
  GetDeterministicGuardrailData,
  GetExpertAnswerData,
  GetExpertAnswerWithResolvedLogsCountData,
  GetExpertReviewData,
  GetMetricsData,
  GetMyselfData,
  GetMyselfFromApiKeyData,
  GetOrganizationAsAdminData,
  GetOrganizationCardDetailsData,
  GetOrganizationData,
  GetOrganizationInvoicesData,
  GetOrganizationMembersData,
  GetOrganizationMembersPublicData,
  GetOrganizationPlanDetailsData,
  GetOrganizationUsageData,
  GetProjectAnalyticsData,
  GetProjectAnalyticsError,
  GetProjectAnalyticsResponse,
  GetProjectData,
  GetProjectEvalsData,
  GetProjectEvalsError,
  GetProjectEvalsResponse,
  GetProjectGuardrailsData,
  GetProjectGuardrailsNextData,
  GetProjectIdFromAccessKeyData,
  GetProjectWithUnaddressedCountsData,
  GetQueryLogData,
  GetRemediationData,
  GetRemediationWithResolvedLogsCountData,
  GetTlmExplanationData,
  GetUserOrganizationPermissionsData,
  GetUserOrganizationsData,
  GetUsersData,
  InviteSmeData,
  InviteSmeError,
  InviteSmeResponse,
  ListAiGuidanceData,
  ListAiGuidanceError,
  ListAiGuidanceResponse,
  ListAppliedToLogsData,
  ListAppliedToLogsError,
  ListAppliedToLogsResponse,
  ListClassificationOptionsData,
  ListClassificationsData,
  ListDeterministicGuardrailsData,
  ListExpertAnswersData,
  ListExpertAnswersError,
  ListExpertAnswersResponse,
  ListExpertReviewAppliedToLogsData,
  ListExpertReviewAppliedToLogsError,
  ListExpertReviewAppliedToLogsResponse,
  ListExpertReviewsData,
  ListExpertReviewsError,
  ListExpertReviewsResponse,
  ListIssuesData,
  ListIssuesError,
  ListIssuesResponse,
  ListLogsByIssueData,
  ListLogsByIssueError,
  ListLogsByIssueResponse,
  ListProjectAccessKeysData,
  ListProjectsAdminData,
  ListProjectsAdminError,
  ListProjectsAdminResponse,
  ListProjectsData,
  ListProjectsError,
  ListProjectsResponse,
  ListQueryLogGroupsData,
  ListQueryLogGroupsError,
  ListQueryLogGroupsResponse,
  ListQueryLogsByGroupData,
  ListQueryLogsByGroupError,
  ListQueryLogsByGroupResponse,
  ListQueryLogsData,
  ListQueryLogsError,
  ListQueryLogsResponse,
  ListRemediationsData,
  ListRemediationsError,
  ListRemediationsResponse,
  ListResolvedLogsData,
  PatchDeterministicEvalFallbackPriorityData,
  PatchDeterministicEvalFallbackPriorityError,
  PatchDeterministicEvalFallbackPriorityResponse,
  PatchDeterministicGuardrailFallbackPriorityData,
  PatchDeterministicGuardrailFallbackPriorityError,
  PatchDeterministicGuardrailFallbackPriorityResponse,
  PatchProjectEvalGuardrailedFallbackPriorityData,
  PatchProjectEvalGuardrailedFallbackPriorityError,
  PatchProjectEvalGuardrailedFallbackPriorityResponse,
  PauseExpertAnswerData,
  PauseExpertAnswerError,
  PauseExpertAnswerResponse,
  PauseRemediationData,
  PauseRemediationError,
  PauseRemediationResponse,
  PublishExpertAnswerData,
  PublishExpertAnswerError,
  PublishExpertAnswerResponse,
  PublishGuidanceData,
  PublishGuidanceError,
  PublishGuidanceResponse,
  PublishRemediationData,
  PublishRemediationError,
  PublishRemediationResponse,
  RefreshApiKeyData,
  RefreshApiKeyResponse,
  RemoveExpertReviewData,
  RemoveExpertReviewError,
  RemoveExpertReviewResponse,
  RemoveProjectEvalData,
  RemoveProjectEvalError,
  RemoveProjectEvalResponse,
  ResendVerificationEmailData,
  ResendVerificationEmailResponse,
  RevokeAccessKeyData,
  RevokeAccessKeyError,
  RevokeAccessKeyResponse,
  RunQueryLogClusteringAdminData,
  RunQueryLogClusteringAdminError,
  SendGuardrailNotificationManualProjectData,
  SendGuardrailNotificationManualProjectError,
  SendGuardrailNotificationManualProjectResponse,
  SendOutdatedRemediationsNotificationManualProjectData,
  SendOutdatedRemediationsNotificationManualProjectError,
  SendOutdatedRemediationsNotificationManualProjectResponse,
  StartRemediationData,
  StartRemediationError,
  StartRemediationResponse,
  SwitchUserOrganizationData,
  SwitchUserOrganizationError,
  SwitchUserOrganizationResponse,
  TlmChatData,
  TlmHealthCheckData,
  UnpauseExpertAnswerData,
  UnpauseExpertAnswerError,
  UnpauseExpertAnswerResponse,
  UnpauseRemediationData,
  UnpauseRemediationError,
  UnpauseRemediationResponse,
  UpdateAccessKeyData,
  UpdateAccessKeyError,
  UpdateAccessKeyResponse,
  UpdateClassificationData,
  UpdateClassificationError,
  UpdateClassificationOptionData,
  UpdateClassificationOptionError,
  UpdateClassificationOptionResponse,
  UpdateClassificationResponse,
  UpdateDeterministicEvalData,
  UpdateDeterministicEvalError,
  UpdateDeterministicEvalResponse,
  UpdateDeterministicGuardrailData,
  UpdateDeterministicGuardrailError,
  UpdateDeterministicGuardrailResponse,
  UpdateExpertReviewData,
  UpdateExpertReviewError,
  UpdateExpertReviewResponse,
  UpdateIssueReviewStatusData,
  UpdateIssueReviewStatusError,
  UpdateIssueReviewStatusResponse,
  UpdateMetadataData,
  UpdateMetadataError,
  UpdateMetadataResponse,
  UpdateOrganizationData,
  UpdateOrganizationError,
  UpdateOrganizationMemberRoleData,
  UpdateOrganizationMemberRoleError,
  UpdateOrganizationMemberRoleResponse,
  UpdateOrganizationResponse,
  UpdateProjectData,
  UpdateProjectError,
  UpdateProjectEvalData,
  UpdateProjectEvalError,
  UpdateProjectEvalResponse,
  UpdateProjectResponse,
  UpdateProjectTemplateStatusData,
  UpdateProjectTemplateStatusError,
  UpdateProjectTemplateStatusResponse,
  UpdateRemediationReviewStatusData,
  UpdateRemediationReviewStatusError,
  UpdateRemediationReviewStatusResponse,
  ValidateQueryData,
  ValidateQueryError,
  ValidateQueryResponse,
} from '../types.gen'

type QueryKey<TOptions extends Options> = [
  Pick<TOptions, 'baseURL' | 'body' | 'headers' | 'path' | 'query'> & {
    _id: string
    _infinite?: boolean
  },
]

const createQueryKey = <TOptions extends Options>(
  id: string,
  options?: TOptions,
  infinite?: boolean
): QueryKey<TOptions>[0] => {
  const params: QueryKey<TOptions>[0] = {
    _id: id,
    baseURL: (options?.client ?? client).getConfig().baseURL,
  } as QueryKey<TOptions>[0]
  if (infinite) {
    params._infinite = infinite
  }
  if (options?.body) {
    params.body = options.body
  }
  if (options?.headers) {
    params.headers = options.headers
  }
  if (options?.path) {
    params.path = options.path
  }
  if (options?.query) {
    params.query = options.query
  }
  return params
}

export const getOrganizationQueryKey = (options?: Options<GetOrganizationData>) => [
  createQueryKey('getOrganization', options),
]

export const getOrganizationOptions = (options?: Options<GetOrganizationData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrganization({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getOrganizationQueryKey(options),
  })
}

export const getUserOrganizationPermissionsQueryKey = (
  options?: Options<GetUserOrganizationPermissionsData>
) => [createQueryKey('getUserOrganizationPermissions', options)]

export const getUserOrganizationPermissionsOptions = (
  options?: Options<GetUserOrganizationPermissionsData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getUserOrganizationPermissions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getUserOrganizationPermissionsQueryKey(options),
  })
}

export const getOrganizationMembersPublicQueryKey = (
  options?: Options<GetOrganizationMembersPublicData>
) => [createQueryKey('getOrganizationMembersPublic', options)]

export const getOrganizationMembersPublicOptions = (
  options?: Options<GetOrganizationMembersPublicData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrganizationMembersPublic({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getOrganizationMembersPublicQueryKey(options),
  })
}

export const getMyselfQueryKey = (options?: Options<GetMyselfData>) => [
  createQueryKey('getMyself', options),
]

export const getMyselfOptions = (options?: Options<GetMyselfData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getMyself({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getMyselfQueryKey(options),
  })
}

export const getMyselfFromApiKeyQueryKey = (options?: Options<GetMyselfFromApiKeyData>) => [
  createQueryKey('getMyselfFromApiKey', options),
]

export const getMyselfFromApiKeyOptions = (options?: Options<GetMyselfFromApiKeyData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getMyselfFromApiKey({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getMyselfFromApiKeyQueryKey(options),
  })
}

export const refreshApiKeyQueryKey = (options?: Options<RefreshApiKeyData>) => [
  createQueryKey('refreshApiKey', options),
]

export const refreshApiKeyOptions = (options?: Options<RefreshApiKeyData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await refreshApiKey({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: refreshApiKeyQueryKey(options),
  })
}

export const refreshApiKeyMutation = (options?: Partial<Options<RefreshApiKeyData>>) => {
  const mutationOptions: UseMutationOptions<
    RefreshApiKeyResponse,
    AxiosError<DefaultError>,
    Options<RefreshApiKeyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await refreshApiKey({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getUserOrganizationsQueryKey = (options?: Options<GetUserOrganizationsData>) => [
  createQueryKey('getUserOrganizations', options),
]

export const getUserOrganizationsOptions = (options?: Options<GetUserOrganizationsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getUserOrganizations({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getUserOrganizationsQueryKey(options),
  })
}

export const activateAccountMutation = (options?: Partial<Options<ActivateAccountData>>) => {
  const mutationOptions: UseMutationOptions<
    ActivateAccountResponse,
    AxiosError<ActivateAccountError>,
    Options<ActivateAccountData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await activateAccount({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const resendVerificationEmailQueryKey = (options?: Options<ResendVerificationEmailData>) => [
  createQueryKey('resendVerificationEmail', options),
]

export const resendVerificationEmailOptions = (options?: Options<ResendVerificationEmailData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await resendVerificationEmail({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: resendVerificationEmailQueryKey(options),
  })
}

export const resendVerificationEmailMutation = (
  options?: Partial<Options<ResendVerificationEmailData>>
) => {
  const mutationOptions: UseMutationOptions<
    ResendVerificationEmailResponse,
    AxiosError<DefaultError>,
    Options<ResendVerificationEmailData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await resendVerificationEmail({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getProjectIdFromAccessKeyQueryKey = (
  options?: Options<GetProjectIdFromAccessKeyData>
) => [createQueryKey('getProjectIdFromAccessKey', options)]

export const getProjectIdFromAccessKeyOptions = (
  options?: Options<GetProjectIdFromAccessKeyData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getProjectIdFromAccessKey({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getProjectIdFromAccessKeyQueryKey(options),
  })
}

export const deleteProjectMutation = (options?: Partial<Options<DeleteProjectData>>) => {
  const mutationOptions: UseMutationOptions<
    DeleteProjectResponse,
    AxiosError<DeleteProjectError>,
    Options<DeleteProjectData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await deleteProject({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getProjectQueryKey = (options?: Options<GetProjectData>) => [
  createQueryKey('getProject', options),
]

export const getProjectOptions = (options?: Options<GetProjectData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getProject({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getProjectQueryKey(options),
  })
}

export const updateProjectMutation = (options?: Partial<Options<UpdateProjectData>>) => {
  const mutationOptions: UseMutationOptions<
    UpdateProjectResponse,
    AxiosError<UpdateProjectError>,
    Options<UpdateProjectData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await updateProject({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getProjectWithUnaddressedCountsQueryKey = (
  options?: Options<GetProjectWithUnaddressedCountsData>
) => [createQueryKey('getProjectWithUnaddressedCounts', options)]

export const getProjectWithUnaddressedCountsOptions = (
  options?: Options<GetProjectWithUnaddressedCountsData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getProjectWithUnaddressedCounts({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getProjectWithUnaddressedCountsQueryKey(options),
  })
}

export const listProjectsQueryKey = (options?: Options<ListProjectsData>) => [
  createQueryKey('listProjects', options),
]

export const listProjectsOptions = (options?: Options<ListProjectsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listProjects({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listProjectsQueryKey(options),
  })
}

const createInfiniteParams = <
  K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>,
>(
  queryKey: QueryKey<Options>,
  page: K
) => {
  const params = queryKey[0]
  if (page.body) {
    params.body = {
      ...(queryKey[0].body as any),
      ...(page.body as any),
    }
  }
  if (page.headers) {
    params.headers = {
      ...queryKey[0].headers,
      ...page.headers,
    }
  }
  if (page.path) {
    params.path = {
      ...(queryKey[0].path as any),
      ...(page.path as any),
    }
  }
  if (page.query) {
    params.query = {
      ...(queryKey[0].query as any),
      ...(page.query as any),
    }
  }
  return params as unknown as typeof page
}

export const listProjectsInfiniteQueryKey = (
  options?: Options<ListProjectsData>
): QueryKey<Options<ListProjectsData>> => [createQueryKey('listProjects', options, true)]

export const listProjectsInfiniteOptions = (options?: Options<ListProjectsData>) => {
  return infiniteQueryOptions<
    ListProjectsResponse,
    AxiosError<ListProjectsError>,
    InfiniteData<ListProjectsResponse>,
    QueryKey<Options<ListProjectsData>>,
    number | Pick<QueryKey<Options<ListProjectsData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListProjectsData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await listProjects({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: listProjectsInfiniteQueryKey(options),
    }
  )
}

export const createProjectQueryKey = (options: Options<CreateProjectData>) => [
  createQueryKey('createProject', options),
]

export const createProjectOptions = (options: Options<CreateProjectData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await createProject({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: createProjectQueryKey(options),
  })
}

export const createProjectMutation = (options?: Partial<Options<CreateProjectData>>) => {
  const mutationOptions: UseMutationOptions<
    CreateProjectResponse,
    AxiosError<CreateProjectError>,
    Options<CreateProjectData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await createProject({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const createProjectFromTemplateQueryKey = (
  options: Options<CreateProjectFromTemplateData>
) => [createQueryKey('createProjectFromTemplate', options)]

export const createProjectFromTemplateOptions = (
  options: Options<CreateProjectFromTemplateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await createProjectFromTemplate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: createProjectFromTemplateQueryKey(options),
  })
}

export const createProjectFromTemplateMutation = (
  options?: Partial<Options<CreateProjectFromTemplateData>>
) => {
  const mutationOptions: UseMutationOptions<
    CreateProjectFromTemplateResponse,
    AxiosError<CreateProjectFromTemplateError>,
    Options<CreateProjectFromTemplateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await createProjectFromTemplate({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const detectQueryQueryKey = (options: Options<DetectQueryData>) => [
  createQueryKey('detectQuery', options),
]

export const detectQueryOptions = (options: Options<DetectQueryData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await detectQuery({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: detectQueryQueryKey(options),
  })
}

export const detectQueryMutation = (options?: Partial<Options<DetectQueryData>>) => {
  const mutationOptions: UseMutationOptions<
    DetectQueryResponse,
    AxiosError<DetectQueryError>,
    Options<DetectQueryData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await detectQuery({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const exportProjectQueryKey = (options?: Options<ExportProjectData>) => [
  createQueryKey('exportProject', options),
]

export const exportProjectOptions = (options?: Options<ExportProjectData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await exportProject({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: exportProjectQueryKey(options),
  })
}

export const exportProjectToS3QueryKey = (options?: Options<ExportProjectToS3Data>) => [
  createQueryKey('exportProjectToS3', options),
]

export const exportProjectToS3Options = (options?: Options<ExportProjectToS3Data>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await exportProjectToS3({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: exportProjectToS3QueryKey(options),
  })
}

export const exportProjectToS3Mutation = (options?: Partial<Options<ExportProjectToS3Data>>) => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<ExportProjectToS3Error>,
    Options<ExportProjectToS3Data>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await exportProjectToS3({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const exportQueryLogGroupsToS3QueryKey = (
  options?: Options<ExportQueryLogGroupsToS3Data>
) => [createQueryKey('exportQueryLogGroupsToS3', options)]

export const exportQueryLogGroupsToS3Options = (
  options?: Options<ExportQueryLogGroupsToS3Data>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await exportQueryLogGroupsToS3({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: exportQueryLogGroupsToS3QueryKey(options),
  })
}

export const exportQueryLogGroupsToS3Mutation = (
  options?: Partial<Options<ExportQueryLogGroupsToS3Data>>
) => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<ExportQueryLogGroupsToS3Error>,
    Options<ExportQueryLogGroupsToS3Data>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await exportQueryLogGroupsToS3({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const consultAiGuidanceQueryKey = (options: Options<ConsultAiGuidanceData>) => [
  createQueryKey('consultAiGuidance', options),
]

export const consultAiGuidanceOptions = (options: Options<ConsultAiGuidanceData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await consultAiGuidance({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: consultAiGuidanceQueryKey(options),
  })
}

export const consultAiGuidanceMutation = (options?: Partial<Options<ConsultAiGuidanceData>>) => {
  const mutationOptions: UseMutationOptions<
    ConsultAiGuidanceResponse,
    AxiosError<ConsultAiGuidanceError>,
    Options<ConsultAiGuidanceData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await consultAiGuidance({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const validateQueryQueryKey = (options: Options<ValidateQueryData>) => [
  createQueryKey('validateQuery', options),
]

export const validateQueryOptions = (options: Options<ValidateQueryData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await validateQuery({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: validateQueryQueryKey(options),
  })
}

export const validateQueryMutation = (options?: Partial<Options<ValidateQueryData>>) => {
  const mutationOptions: UseMutationOptions<
    ValidateQueryResponse,
    AxiosError<ValidateQueryError>,
    Options<ValidateQueryData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await validateQuery({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getProjectEvalsQueryKey = (options?: Options<GetProjectEvalsData>) => [
  createQueryKey('getProjectEvals', options),
]

export const getProjectEvalsOptions = (options?: Options<GetProjectEvalsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getProjectEvals({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getProjectEvalsQueryKey(options),
  })
}

export const getProjectEvalsInfiniteQueryKey = (
  options?: Options<GetProjectEvalsData>
): QueryKey<Options<GetProjectEvalsData>> => [createQueryKey('getProjectEvals', options, true)]

export const getProjectEvalsInfiniteOptions = (options?: Options<GetProjectEvalsData>) => {
  return infiniteQueryOptions<
    GetProjectEvalsResponse,
    AxiosError<GetProjectEvalsError>,
    InfiniteData<GetProjectEvalsResponse>,
    QueryKey<Options<GetProjectEvalsData>>,
    number | Pick<QueryKey<Options<GetProjectEvalsData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetProjectEvalsData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await getProjectEvals({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: getProjectEvalsInfiniteQueryKey(options),
    }
  )
}

export const addProjectEvalQueryKey = (options: Options<AddProjectEvalData>) => [
  createQueryKey('addProjectEval', options),
]

export const addProjectEvalOptions = (options: Options<AddProjectEvalData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await addProjectEval({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: addProjectEvalQueryKey(options),
  })
}

export const addProjectEvalMutation = (options?: Partial<Options<AddProjectEvalData>>) => {
  const mutationOptions: UseMutationOptions<
    AddProjectEvalResponse,
    AxiosError<AddProjectEvalError>,
    Options<AddProjectEvalData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await addProjectEval({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getProjectGuardrailsQueryKey = (options?: Options<GetProjectGuardrailsData>) => [
  createQueryKey('getProjectGuardrails', options),
]

export const getProjectGuardrailsOptions = (options?: Options<GetProjectGuardrailsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getProjectGuardrails({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getProjectGuardrailsQueryKey(options),
  })
}

export const getProjectGuardrailsNextQueryKey = (
  options?: Options<GetProjectGuardrailsNextData>
) => [createQueryKey('getProjectGuardrailsNext', options)]

export const getProjectGuardrailsNextOptions = (
  options?: Options<GetProjectGuardrailsNextData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getProjectGuardrailsNext({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getProjectGuardrailsNextQueryKey(options),
  })
}

export const removeProjectEvalMutation = (options?: Partial<Options<RemoveProjectEvalData>>) => {
  const mutationOptions: UseMutationOptions<
    RemoveProjectEvalResponse,
    AxiosError<RemoveProjectEvalError>,
    Options<RemoveProjectEvalData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await removeProjectEval({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const updateProjectEvalMutation = (options?: Partial<Options<UpdateProjectEvalData>>) => {
  const mutationOptions: UseMutationOptions<
    UpdateProjectEvalResponse,
    AxiosError<UpdateProjectEvalError>,
    Options<UpdateProjectEvalData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await updateProjectEval({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const patchProjectEvalGuardrailedFallbackPriorityMutation = (
  options?: Partial<Options<PatchProjectEvalGuardrailedFallbackPriorityData>>
) => {
  const mutationOptions: UseMutationOptions<
    PatchProjectEvalGuardrailedFallbackPriorityResponse,
    AxiosError<PatchProjectEvalGuardrailedFallbackPriorityError>,
    Options<PatchProjectEvalGuardrailedFallbackPriorityData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await patchProjectEvalGuardrailedFallbackPriority({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const inviteSmeQueryKey = (options: Options<InviteSmeData>) => [
  createQueryKey('inviteSme', options),
]

export const inviteSmeOptions = (options: Options<InviteSmeData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await inviteSme({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: inviteSmeQueryKey(options),
  })
}

export const inviteSmeMutation = (options?: Partial<Options<InviteSmeData>>) => {
  const mutationOptions: UseMutationOptions<
    InviteSmeResponse,
    AxiosError<InviteSmeError>,
    Options<InviteSmeData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await inviteSme({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const sendGuardrailNotificationManualProjectQueryKey = (
  options: Options<SendGuardrailNotificationManualProjectData>
) => [createQueryKey('sendGuardrailNotificationManualProject', options)]

export const sendGuardrailNotificationManualProjectOptions = (
  options: Options<SendGuardrailNotificationManualProjectData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await sendGuardrailNotificationManualProject({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: sendGuardrailNotificationManualProjectQueryKey(options),
  })
}

export const sendGuardrailNotificationManualProjectMutation = (
  options?: Partial<Options<SendGuardrailNotificationManualProjectData>>
) => {
  const mutationOptions: UseMutationOptions<
    SendGuardrailNotificationManualProjectResponse,
    AxiosError<SendGuardrailNotificationManualProjectError>,
    Options<SendGuardrailNotificationManualProjectData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await sendGuardrailNotificationManualProject({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const sendOutdatedRemediationsNotificationManualProjectQueryKey = (
  options: Options<SendOutdatedRemediationsNotificationManualProjectData>
) => [createQueryKey('sendOutdatedRemediationsNotificationManualProject', options)]

export const sendOutdatedRemediationsNotificationManualProjectOptions = (
  options: Options<SendOutdatedRemediationsNotificationManualProjectData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await sendOutdatedRemediationsNotificationManualProject({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: sendOutdatedRemediationsNotificationManualProjectQueryKey(options),
  })
}

export const sendOutdatedRemediationsNotificationManualProjectMutation = (
  options?: Partial<Options<SendOutdatedRemediationsNotificationManualProjectData>>
) => {
  const mutationOptions: UseMutationOptions<
    SendOutdatedRemediationsNotificationManualProjectResponse,
    AxiosError<SendOutdatedRemediationsNotificationManualProjectError>,
    Options<SendOutdatedRemediationsNotificationManualProjectData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await sendOutdatedRemediationsNotificationManualProject({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const generateRegexQueryKey = (options: Options<GenerateRegexData>) => [
  createQueryKey('generateRegex', options),
]

export const generateRegexOptions = (options: Options<GenerateRegexData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await generateRegex({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: generateRegexQueryKey(options),
  })
}

export const generateRegexMutation = (options?: Partial<Options<GenerateRegexData>>) => {
  const mutationOptions: UseMutationOptions<
    GenerateRegexResponse2,
    AxiosError<GenerateRegexError>,
    Options<GenerateRegexData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await generateRegex({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const deleteAccessKeyMutation = (options?: Partial<Options<DeleteAccessKeyData>>) => {
  const mutationOptions: UseMutationOptions<
    DeleteAccessKeyResponse,
    AxiosError<DeleteAccessKeyError>,
    Options<DeleteAccessKeyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await deleteAccessKey({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getAccessKeyQueryKey = (options?: Options<GetAccessKeyData>) => [
  createQueryKey('getAccessKey', options),
]

export const getAccessKeyOptions = (options?: Options<GetAccessKeyData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAccessKey({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getAccessKeyQueryKey(options),
  })
}

export const updateAccessKeyMutation = (options?: Partial<Options<UpdateAccessKeyData>>) => {
  const mutationOptions: UseMutationOptions<
    UpdateAccessKeyResponse,
    AxiosError<UpdateAccessKeyError>,
    Options<UpdateAccessKeyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await updateAccessKey({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const listProjectAccessKeysQueryKey = (options?: Options<ListProjectAccessKeysData>) => [
  createQueryKey('listProjectAccessKeys', options),
]

export const listProjectAccessKeysOptions = (options?: Options<ListProjectAccessKeysData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listProjectAccessKeys({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listProjectAccessKeysQueryKey(options),
  })
}

export const createAccessKeyQueryKey = (options: Options<CreateAccessKeyData>) => [
  createQueryKey('createAccessKey', options),
]

export const createAccessKeyOptions = (options: Options<CreateAccessKeyData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await createAccessKey({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: createAccessKeyQueryKey(options),
  })
}

export const createAccessKeyMutation = (options?: Partial<Options<CreateAccessKeyData>>) => {
  const mutationOptions: UseMutationOptions<
    CreateAccessKeyResponse,
    AxiosError<CreateAccessKeyError>,
    Options<CreateAccessKeyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await createAccessKey({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const revokeAccessKeyQueryKey = (options?: Options<RevokeAccessKeyData>) => [
  createQueryKey('revokeAccessKey', options),
]

export const revokeAccessKeyOptions = (options?: Options<RevokeAccessKeyData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await revokeAccessKey({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: revokeAccessKeyQueryKey(options),
  })
}

export const revokeAccessKeyMutation = (options?: Partial<Options<RevokeAccessKeyData>>) => {
  const mutationOptions: UseMutationOptions<
    RevokeAccessKeyResponse,
    AxiosError<RevokeAccessKeyError>,
    Options<RevokeAccessKeyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await revokeAccessKey({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getClassificationsDisplayQueryKey = (
  options?: Options<GetClassificationsDisplayData>
) => [createQueryKey('getClassificationsDisplay', options)]

export const getClassificationsDisplayOptions = (
  options?: Options<GetClassificationsDisplayData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getClassificationsDisplay({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getClassificationsDisplayQueryKey(options),
  })
}

export const deleteClassificationMutation = (
  options?: Partial<Options<DeleteClassificationData>>
) => {
  const mutationOptions: UseMutationOptions<
    DeleteClassificationResponse,
    AxiosError<DeleteClassificationError>,
    Options<DeleteClassificationData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await deleteClassification({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getClassificationQueryKey = (options?: Options<GetClassificationData>) => [
  createQueryKey('getClassification', options),
]

export const getClassificationOptions = (options?: Options<GetClassificationData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getClassification({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getClassificationQueryKey(options),
  })
}

export const updateClassificationMutation = (
  options?: Partial<Options<UpdateClassificationData>>
) => {
  const mutationOptions: UseMutationOptions<
    UpdateClassificationResponse,
    AxiosError<UpdateClassificationError>,
    Options<UpdateClassificationData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await updateClassification({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const listClassificationsQueryKey = (options?: Options<ListClassificationsData>) => [
  createQueryKey('listClassifications', options),
]

export const listClassificationsOptions = (options?: Options<ListClassificationsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listClassifications({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listClassificationsQueryKey(options),
  })
}

export const createClassificationQueryKey = (options: Options<CreateClassificationData>) => [
  createQueryKey('createClassification', options),
]

export const createClassificationOptions = (options: Options<CreateClassificationData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await createClassification({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: createClassificationQueryKey(options),
  })
}

export const createClassificationMutation = (
  options?: Partial<Options<CreateClassificationData>>
) => {
  const mutationOptions: UseMutationOptions<
    CreateClassificationResponse,
    AxiosError<CreateClassificationError>,
    Options<CreateClassificationData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await createClassification({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const listClassificationOptionsQueryKey = (
  options?: Options<ListClassificationOptionsData>
) => [createQueryKey('listClassificationOptions', options)]

export const listClassificationOptionsOptions = (
  options?: Options<ListClassificationOptionsData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listClassificationOptions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listClassificationOptionsQueryKey(options),
  })
}

export const createClassificationOptionQueryKey = (
  options: Options<CreateClassificationOptionData>
) => [createQueryKey('createClassificationOption', options)]

export const createClassificationOptionOptions = (
  options: Options<CreateClassificationOptionData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await createClassificationOption({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: createClassificationOptionQueryKey(options),
  })
}

export const createClassificationOptionMutation = (
  options?: Partial<Options<CreateClassificationOptionData>>
) => {
  const mutationOptions: UseMutationOptions<
    CreateClassificationOptionResponse,
    AxiosError<CreateClassificationOptionError>,
    Options<CreateClassificationOptionData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await createClassificationOption({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const deleteClassificationOptionMutation = (
  options?: Partial<Options<DeleteClassificationOptionData>>
) => {
  const mutationOptions: UseMutationOptions<
    DeleteClassificationOptionResponse,
    AxiosError<DeleteClassificationOptionError>,
    Options<DeleteClassificationOptionData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await deleteClassificationOption({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getClassificationOptionQueryKey = (options?: Options<GetClassificationOptionData>) => [
  createQueryKey('getClassificationOption', options),
]

export const getClassificationOptionOptions = (options?: Options<GetClassificationOptionData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getClassificationOption({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getClassificationOptionQueryKey(options),
  })
}

export const updateClassificationOptionMutation = (
  options?: Partial<Options<UpdateClassificationOptionData>>
) => {
  const mutationOptions: UseMutationOptions<
    UpdateClassificationOptionResponse,
    AxiosError<UpdateClassificationOptionError>,
    Options<UpdateClassificationOptionData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await updateClassificationOption({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getOrganizationUsageQueryKey = (options?: Options<GetOrganizationUsageData>) => [
  createQueryKey('getOrganizationUsage', options),
]

export const getOrganizationUsageOptions = (options?: Options<GetOrganizationUsageData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrganizationUsage({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getOrganizationUsageQueryKey(options),
  })
}

export const getOrganizationInvoicesQueryKey = (options?: Options<GetOrganizationInvoicesData>) => [
  createQueryKey('getOrganizationInvoices', options),
]

export const getOrganizationInvoicesOptions = (options?: Options<GetOrganizationInvoicesData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrganizationInvoices({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getOrganizationInvoicesQueryKey(options),
  })
}

export const getOrganizationCardDetailsQueryKey = (
  options?: Options<GetOrganizationCardDetailsData>
) => [createQueryKey('getOrganizationCardDetails', options)]

export const getOrganizationCardDetailsOptions = (
  options?: Options<GetOrganizationCardDetailsData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrganizationCardDetails({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getOrganizationCardDetailsQueryKey(options),
  })
}

export const createOrganizationSetupIntentQueryKey = (
  options?: Options<CreateOrganizationSetupIntentData>
) => [createQueryKey('createOrganizationSetupIntent', options)]

export const createOrganizationSetupIntentOptions = (
  options?: Options<CreateOrganizationSetupIntentData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await createOrganizationSetupIntent({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: createOrganizationSetupIntentQueryKey(options),
  })
}

export const createOrganizationSetupIntentMutation = (
  options?: Partial<Options<CreateOrganizationSetupIntentData>>
) => {
  const mutationOptions: UseMutationOptions<
    CreateOrganizationSetupIntentResponse,
    AxiosError<CreateOrganizationSetupIntentError>,
    Options<CreateOrganizationSetupIntentData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await createOrganizationSetupIntent({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getOrganizationPlanDetailsQueryKey = (
  options?: Options<GetOrganizationPlanDetailsData>
) => [createQueryKey('getOrganizationPlanDetails', options)]

export const getOrganizationPlanDetailsOptions = (
  options?: Options<GetOrganizationPlanDetailsData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrganizationPlanDetails({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getOrganizationPlanDetailsQueryKey(options),
  })
}

export const checkCleanlabAdminQueryKey = (options?: Options<CheckCleanlabAdminData>) => [
  createQueryKey('checkCleanlabAdmin', options),
]

export const checkCleanlabAdminOptions = (options?: Options<CheckCleanlabAdminData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await checkCleanlabAdmin({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: checkCleanlabAdminQueryKey(options),
  })
}

export const getAllManagedOrganizationsQueryKey = (
  options?: Options<GetAllManagedOrganizationsData>
) => [createQueryKey('getAllManagedOrganizations', options)]

export const getAllManagedOrganizationsOptions = (
  options?: Options<GetAllManagedOrganizationsData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAllManagedOrganizations({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getAllManagedOrganizationsQueryKey(options),
  })
}

export const createManagedOrganizationQueryKey = (
  options: Options<CreateManagedOrganizationData>
) => [createQueryKey('createManagedOrganization', options)]

export const createManagedOrganizationOptions = (
  options: Options<CreateManagedOrganizationData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await createManagedOrganization({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: createManagedOrganizationQueryKey(options),
  })
}

export const createManagedOrganizationMutation = (
  options?: Partial<Options<CreateManagedOrganizationData>>
) => {
  const mutationOptions: UseMutationOptions<
    CreateManagedOrganizationResponse,
    AxiosError<CreateManagedOrganizationError>,
    Options<CreateManagedOrganizationData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await createManagedOrganization({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getAllIndividualOrganizationsQueryKey = (
  options?: Options<GetAllIndividualOrganizationsData>
) => [createQueryKey('getAllIndividualOrganizations', options)]

export const getAllIndividualOrganizationsOptions = (
  options?: Options<GetAllIndividualOrganizationsData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAllIndividualOrganizations({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getAllIndividualOrganizationsQueryKey(options),
  })
}

export const getOrganizationMembersQueryKey = (options?: Options<GetOrganizationMembersData>) => [
  createQueryKey('getOrganizationMembers', options),
]

export const getOrganizationMembersOptions = (options?: Options<GetOrganizationMembersData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrganizationMembers({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getOrganizationMembersQueryKey(options),
  })
}

export const getOrganizationAsAdminQueryKey = (options?: Options<GetOrganizationAsAdminData>) => [
  createQueryKey('getOrganizationAsAdmin', options),
]

export const getOrganizationAsAdminOptions = (options?: Options<GetOrganizationAsAdminData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrganizationAsAdmin({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getOrganizationAsAdminQueryKey(options),
  })
}

export const updateOrganizationMutation = (options?: Partial<Options<UpdateOrganizationData>>) => {
  const mutationOptions: UseMutationOptions<
    UpdateOrganizationResponse,
    AxiosError<UpdateOrganizationError>,
    Options<UpdateOrganizationData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await updateOrganization({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const updateOrganizationMemberRoleMutation = (
  options?: Partial<Options<UpdateOrganizationMemberRoleData>>
) => {
  const mutationOptions: UseMutationOptions<
    UpdateOrganizationMemberRoleResponse,
    AxiosError<UpdateOrganizationMemberRoleError>,
    Options<UpdateOrganizationMemberRoleData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await updateOrganizationMemberRole({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getUsersQueryKey = (options?: Options<GetUsersData>) => [
  createQueryKey('getUsers', options),
]

export const getUsersOptions = (options?: Options<GetUsersData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getUsers({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getUsersQueryKey(options),
  })
}

export const deleteUserMutation = (options?: Partial<Options<DeleteUserData>>) => {
  const mutationOptions: UseMutationOptions<
    DeleteUserResponse,
    AxiosError<DeleteUserError>,
    Options<DeleteUserData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await deleteUser({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const switchUserOrganizationMutation = (
  options?: Partial<Options<SwitchUserOrganizationData>>
) => {
  const mutationOptions: UseMutationOptions<
    SwitchUserOrganizationResponse,
    AxiosError<SwitchUserOrganizationError>,
    Options<SwitchUserOrganizationData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await switchUserOrganization({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const addProjectQueryLogGroupRanksQueryKey = (
  options: Options<AddProjectQueryLogGroupRanksData>
) => [createQueryKey('addProjectQueryLogGroupRanks', options)]

export const addProjectQueryLogGroupRanksOptions = (
  options: Options<AddProjectQueryLogGroupRanksData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await addProjectQueryLogGroupRanks({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: addProjectQueryLogGroupRanksQueryKey(options),
  })
}

export const addProjectQueryLogGroupRanksMutation = (
  options?: Partial<Options<AddProjectQueryLogGroupRanksData>>
) => {
  const mutationOptions: UseMutationOptions<
    AddProjectQueryLogGroupRanksResponse,
    AxiosError<AddProjectQueryLogGroupRanksError>,
    Options<AddProjectQueryLogGroupRanksData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await addProjectQueryLogGroupRanks({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const runQueryLogClusteringAdminQueryKey = (
  options?: Options<RunQueryLogClusteringAdminData>
) => [createQueryKey('runQueryLogClusteringAdmin', options)]

export const runQueryLogClusteringAdminOptions = (
  options?: Options<RunQueryLogClusteringAdminData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await runQueryLogClusteringAdmin({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: runQueryLogClusteringAdminQueryKey(options),
  })
}

export const runQueryLogClusteringAdminMutation = (
  options?: Partial<Options<RunQueryLogClusteringAdminData>>
) => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<RunQueryLogClusteringAdminError>,
    Options<RunQueryLogClusteringAdminData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await runQueryLogClusteringAdmin({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getClusteringStatusAdminQueryKey = (
  options?: Options<GetClusteringStatusAdminData>
) => [createQueryKey('getClusteringStatusAdmin', options)]

export const getClusteringStatusAdminOptions = (
  options?: Options<GetClusteringStatusAdminData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getClusteringStatusAdmin({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getClusteringStatusAdminQueryKey(options),
  })
}

export const listProjectsAdminQueryKey = (options?: Options<ListProjectsAdminData>) => [
  createQueryKey('listProjectsAdmin', options),
]

export const listProjectsAdminOptions = (options?: Options<ListProjectsAdminData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listProjectsAdmin({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listProjectsAdminQueryKey(options),
  })
}

export const listProjectsAdminInfiniteQueryKey = (
  options?: Options<ListProjectsAdminData>
): QueryKey<Options<ListProjectsAdminData>> => [createQueryKey('listProjectsAdmin', options, true)]

export const listProjectsAdminInfiniteOptions = (options?: Options<ListProjectsAdminData>) => {
  return infiniteQueryOptions<
    ListProjectsAdminResponse,
    AxiosError<ListProjectsAdminError>,
    InfiniteData<ListProjectsAdminResponse>,
    QueryKey<Options<ListProjectsAdminData>>,
    | number
    | Pick<QueryKey<Options<ListProjectsAdminData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListProjectsAdminData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await listProjectsAdmin({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: listProjectsAdminInfiniteQueryKey(options),
    }
  )
}

export const copyProjectSettingsMutation = (
  options?: Partial<Options<CopyProjectSettingsData>>
) => {
  const mutationOptions: UseMutationOptions<
    CopyProjectSettingsResponse,
    AxiosError<CopyProjectSettingsError>,
    Options<CopyProjectSettingsData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await copyProjectSettings({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const updateProjectTemplateStatusMutation = (
  options?: Partial<Options<UpdateProjectTemplateStatusData>>
) => {
  const mutationOptions: UseMutationOptions<
    UpdateProjectTemplateStatusResponse,
    AxiosError<UpdateProjectTemplateStatusError>,
    Options<UpdateProjectTemplateStatusData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await updateProjectTemplateStatus({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getProjectAnalyticsQueryKey = (options?: Options<GetProjectAnalyticsData>) => [
  createQueryKey('getProjectAnalytics', options),
]

export const getProjectAnalyticsOptions = (options?: Options<GetProjectAnalyticsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getProjectAnalytics({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getProjectAnalyticsQueryKey(options),
  })
}

export const getProjectAnalyticsInfiniteQueryKey = (
  options?: Options<GetProjectAnalyticsData>
): QueryKey<Options<GetProjectAnalyticsData>> => [
  createQueryKey('getProjectAnalytics', options, true),
]

export const getProjectAnalyticsInfiniteOptions = (options?: Options<GetProjectAnalyticsData>) => {
  return infiniteQueryOptions<
    GetProjectAnalyticsResponse,
    AxiosError<GetProjectAnalyticsError>,
    InfiniteData<GetProjectAnalyticsResponse>,
    QueryKey<Options<GetProjectAnalyticsData>>,
    | number
    | null
    | Pick<QueryKey<Options<GetProjectAnalyticsData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetProjectAnalyticsData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  start: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await getProjectAnalytics({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: getProjectAnalyticsInfiniteQueryKey(options),
    }
  )
}

export const listQueryLogsQueryKey = (options?: Options<ListQueryLogsData>) => [
  createQueryKey('listQueryLogs', options),
]

export const listQueryLogsOptions = (options?: Options<ListQueryLogsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listQueryLogs({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listQueryLogsQueryKey(options),
  })
}

export const listQueryLogsInfiniteQueryKey = (
  options?: Options<ListQueryLogsData>
): QueryKey<Options<ListQueryLogsData>> => [createQueryKey('listQueryLogs', options, true)]

export const listQueryLogsInfiniteOptions = (options?: Options<ListQueryLogsData>) => {
  return infiniteQueryOptions<
    ListQueryLogsResponse,
    AxiosError<ListQueryLogsError>,
    InfiniteData<ListQueryLogsResponse>,
    QueryKey<Options<ListQueryLogsData>>,
    number | Pick<QueryKey<Options<ListQueryLogsData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListQueryLogsData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await listQueryLogs({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: listQueryLogsInfiniteQueryKey(options),
    }
  )
}

export const listQueryLogGroupsQueryKey = (options?: Options<ListQueryLogGroupsData>) => [
  createQueryKey('listQueryLogGroups', options),
]

export const listQueryLogGroupsOptions = (options?: Options<ListQueryLogGroupsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listQueryLogGroups({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listQueryLogGroupsQueryKey(options),
  })
}

export const listQueryLogGroupsInfiniteQueryKey = (
  options?: Options<ListQueryLogGroupsData>
): QueryKey<Options<ListQueryLogGroupsData>> => [
  createQueryKey('listQueryLogGroups', options, true),
]

export const listQueryLogGroupsInfiniteOptions = (options?: Options<ListQueryLogGroupsData>) => {
  return infiniteQueryOptions<
    ListQueryLogGroupsResponse,
    AxiosError<ListQueryLogGroupsError>,
    InfiniteData<ListQueryLogGroupsResponse>,
    QueryKey<Options<ListQueryLogGroupsData>>,
    | number
    | Pick<QueryKey<Options<ListQueryLogGroupsData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListQueryLogGroupsData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await listQueryLogGroups({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: listQueryLogGroupsInfiniteQueryKey(options),
    }
  )
}

export const listQueryLogsByGroupQueryKey = (options?: Options<ListQueryLogsByGroupData>) => [
  createQueryKey('listQueryLogsByGroup', options),
]

export const listQueryLogsByGroupOptions = (options?: Options<ListQueryLogsByGroupData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listQueryLogsByGroup({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listQueryLogsByGroupQueryKey(options),
  })
}

export const listQueryLogsByGroupInfiniteQueryKey = (
  options?: Options<ListQueryLogsByGroupData>
): QueryKey<Options<ListQueryLogsByGroupData>> => [
  createQueryKey('listQueryLogsByGroup', options, true),
]

export const listQueryLogsByGroupInfiniteOptions = (
  options?: Options<ListQueryLogsByGroupData>
) => {
  return infiniteQueryOptions<
    ListQueryLogsByGroupResponse,
    AxiosError<ListQueryLogsByGroupError>,
    InfiniteData<ListQueryLogsByGroupResponse>,
    QueryKey<Options<ListQueryLogsByGroupData>>,
    | number
    | Pick<QueryKey<Options<ListQueryLogsByGroupData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListQueryLogsByGroupData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await listQueryLogsByGroup({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: listQueryLogsByGroupInfiniteQueryKey(options),
    }
  )
}

export const deleteQueryLogMutation = (options?: Partial<Options<DeleteQueryLogData>>) => {
  const mutationOptions: UseMutationOptions<
    DeleteQueryLogResponse,
    AxiosError<DeleteQueryLogError>,
    Options<DeleteQueryLogData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await deleteQueryLog({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getQueryLogQueryKey = (options?: Options<GetQueryLogData>) => [
  createQueryKey('getQueryLog', options),
]

export const getQueryLogOptions = (options?: Options<GetQueryLogData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getQueryLog({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getQueryLogQueryKey(options),
  })
}

export const startRemediationQueryKey = (options?: Options<StartRemediationData>) => [
  createQueryKey('startRemediation', options),
]

export const startRemediationOptions = (options?: Options<StartRemediationData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await startRemediation({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: startRemediationQueryKey(options),
  })
}

export const startRemediationMutation = (options?: Partial<Options<StartRemediationData>>) => {
  const mutationOptions: UseMutationOptions<
    StartRemediationResponse,
    AxiosError<StartRemediationError>,
    Options<StartRemediationData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await startRemediation({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getConversationHistoryQueryKey = (options?: Options<GetConversationHistoryData>) => [
  createQueryKey('getConversationHistory', options),
]

export const getConversationHistoryOptions = (options?: Options<GetConversationHistoryData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getConversationHistory({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getConversationHistoryQueryKey(options),
  })
}

export const addUserFeedbackQueryKey = (options: Options<AddUserFeedbackData>) => [
  createQueryKey('addUserFeedback', options),
]

export const addUserFeedbackOptions = (options: Options<AddUserFeedbackData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await addUserFeedback({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: addUserFeedbackQueryKey(options),
  })
}

export const addUserFeedbackMutation = (options?: Partial<Options<AddUserFeedbackData>>) => {
  const mutationOptions: UseMutationOptions<
    AddUserFeedbackResponse,
    AxiosError<AddUserFeedbackError>,
    Options<AddUserFeedbackData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await addUserFeedback({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const updateMetadataMutation = (options?: Partial<Options<UpdateMetadataData>>) => {
  const mutationOptions: UseMutationOptions<
    UpdateMetadataResponse,
    AxiosError<UpdateMetadataError>,
    Options<UpdateMetadataData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await updateMetadata({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const addExpertReviewQueryKey = (options: Options<AddExpertReviewData>) => [
  createQueryKey('addExpertReview', options),
]

export const addExpertReviewOptions = (options: Options<AddExpertReviewData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await addExpertReview({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: addExpertReviewQueryKey(options),
  })
}

export const addExpertReviewMutation = (options?: Partial<Options<AddExpertReviewData>>) => {
  const mutationOptions: UseMutationOptions<
    AddExpertReviewResponse,
    AxiosError<AddExpertReviewError>,
    Options<AddExpertReviewData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await addExpertReview({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const removeExpertReviewMutation = (options?: Partial<Options<RemoveExpertReviewData>>) => {
  const mutationOptions: UseMutationOptions<
    RemoveExpertReviewResponse,
    AxiosError<RemoveExpertReviewError>,
    Options<RemoveExpertReviewData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await removeExpertReview({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getTlmExplanationQueryKey = (options?: Options<GetTlmExplanationData>) => [
  createQueryKey('getTlmExplanation', options),
]

export const getTlmExplanationOptions = (options?: Options<GetTlmExplanationData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getTlmExplanation({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getTlmExplanationQueryKey(options),
  })
}

export const getCurrentPromptQueryKey = (options?: Options<GetCurrentPromptData>) => [
  createQueryKey('getCurrentPrompt', options),
]

export const getCurrentPromptOptions = (options?: Options<GetCurrentPromptData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCurrentPrompt({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getCurrentPromptQueryKey(options),
  })
}

export const createPromptRecommendationQueryKey = (
  options?: Options<CreatePromptRecommendationData>
) => [createQueryKey('createPromptRecommendation', options)]

export const createPromptRecommendationOptions = (
  options?: Options<CreatePromptRecommendationData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await createPromptRecommendation({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: createPromptRecommendationQueryKey(options),
  })
}

export const createPromptRecommendationMutation = (
  options?: Partial<Options<CreatePromptRecommendationData>>
) => {
  const mutationOptions: UseMutationOptions<
    CreatePromptRecommendationResponse,
    AxiosError<CreatePromptRecommendationError>,
    Options<CreatePromptRecommendationData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await createPromptRecommendation({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const listRemediationsQueryKey = (options?: Options<ListRemediationsData>) => [
  createQueryKey('listRemediations', options),
]

export const listRemediationsOptions = (options?: Options<ListRemediationsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listRemediations({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listRemediationsQueryKey(options),
  })
}

export const listRemediationsInfiniteQueryKey = (
  options?: Options<ListRemediationsData>
): QueryKey<Options<ListRemediationsData>> => [createQueryKey('listRemediations', options, true)]

export const listRemediationsInfiniteOptions = (options?: Options<ListRemediationsData>) => {
  return infiniteQueryOptions<
    ListRemediationsResponse,
    AxiosError<ListRemediationsError>,
    InfiniteData<ListRemediationsResponse>,
    QueryKey<Options<ListRemediationsData>>,
    number | Pick<QueryKey<Options<ListRemediationsData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListRemediationsData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await listRemediations({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: listRemediationsInfiniteQueryKey(options),
    }
  )
}

export const createRemediationQueryKey = (options: Options<CreateRemediationData>) => [
  createQueryKey('createRemediation', options),
]

export const createRemediationOptions = (options: Options<CreateRemediationData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await createRemediation({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: createRemediationQueryKey(options),
  })
}

export const createRemediationMutation = (options?: Partial<Options<CreateRemediationData>>) => {
  const mutationOptions: UseMutationOptions<
    CreateRemediationResponse,
    AxiosError<CreateRemediationError>,
    Options<CreateRemediationData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await createRemediation({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const deleteRemediationMutation = (options?: Partial<Options<DeleteRemediationData>>) => {
  const mutationOptions: UseMutationOptions<
    DeleteRemediationResponse,
    AxiosError<DeleteRemediationError>,
    Options<DeleteRemediationData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await deleteRemediation({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getRemediationQueryKey = (options?: Options<GetRemediationData>) => [
  createQueryKey('getRemediation', options),
]

export const getRemediationOptions = (options?: Options<GetRemediationData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getRemediation({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getRemediationQueryKey(options),
  })
}

export const getRemediationWithResolvedLogsCountQueryKey = (
  options?: Options<GetRemediationWithResolvedLogsCountData>
) => [createQueryKey('getRemediationWithResolvedLogsCount', options)]

export const getRemediationWithResolvedLogsCountOptions = (
  options?: Options<GetRemediationWithResolvedLogsCountData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getRemediationWithResolvedLogsCount({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getRemediationWithResolvedLogsCountQueryKey(options),
  })
}

export const editDraftAnswerMutation = (options?: Partial<Options<EditDraftAnswerData>>) => {
  const mutationOptions: UseMutationOptions<
    EditDraftAnswerResponse,
    AxiosError<EditDraftAnswerError>,
    Options<EditDraftAnswerData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await editDraftAnswer({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const editAnswerMutation = (options?: Partial<Options<EditAnswerData>>) => {
  const mutationOptions: UseMutationOptions<
    EditAnswerResponse,
    AxiosError<EditAnswerError>,
    Options<EditAnswerData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await editAnswer({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const publishRemediationMutation = (options?: Partial<Options<PublishRemediationData>>) => {
  const mutationOptions: UseMutationOptions<
    PublishRemediationResponse,
    AxiosError<PublishRemediationError>,
    Options<PublishRemediationData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await publishRemediation({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const pauseRemediationMutation = (options?: Partial<Options<PauseRemediationData>>) => {
  const mutationOptions: UseMutationOptions<
    PauseRemediationResponse,
    AxiosError<PauseRemediationError>,
    Options<PauseRemediationData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await pauseRemediation({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const unpauseRemediationMutation = (options?: Partial<Options<UnpauseRemediationData>>) => {
  const mutationOptions: UseMutationOptions<
    UnpauseRemediationResponse,
    AxiosError<UnpauseRemediationError>,
    Options<UnpauseRemediationData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await unpauseRemediation({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const listResolvedLogsQueryKey = (options?: Options<ListResolvedLogsData>) => [
  createQueryKey('listResolvedLogs', options),
]

export const listResolvedLogsOptions = (options?: Options<ListResolvedLogsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listResolvedLogs({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listResolvedLogsQueryKey(options),
  })
}

export const updateRemediationReviewStatusMutation = (
  options?: Partial<Options<UpdateRemediationReviewStatusData>>
) => {
  const mutationOptions: UseMutationOptions<
    UpdateRemediationReviewStatusResponse,
    AxiosError<UpdateRemediationReviewStatusError>,
    Options<UpdateRemediationReviewStatusData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await updateRemediationReviewStatus({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const listDeterministicGuardrailsQueryKey = (
  options?: Options<ListDeterministicGuardrailsData>
) => [createQueryKey('listDeterministicGuardrails', options)]

export const listDeterministicGuardrailsOptions = (
  options?: Options<ListDeterministicGuardrailsData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listDeterministicGuardrails({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listDeterministicGuardrailsQueryKey(options),
  })
}

export const createDeterministicGuardrailQueryKey = (
  options: Options<CreateDeterministicGuardrailData>
) => [createQueryKey('createDeterministicGuardrail', options)]

export const createDeterministicGuardrailOptions = (
  options: Options<CreateDeterministicGuardrailData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await createDeterministicGuardrail({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: createDeterministicGuardrailQueryKey(options),
  })
}

export const createDeterministicGuardrailMutation = (
  options?: Partial<Options<CreateDeterministicGuardrailData>>
) => {
  const mutationOptions: UseMutationOptions<
    CreateDeterministicGuardrailResponse,
    AxiosError<CreateDeterministicGuardrailError>,
    Options<CreateDeterministicGuardrailData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await createDeterministicGuardrail({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const deleteDeterministicGuardrailMutation = (
  options?: Partial<Options<DeleteDeterministicGuardrailData>>
) => {
  const mutationOptions: UseMutationOptions<
    DeleteDeterministicGuardrailResponse,
    AxiosError<DeleteDeterministicGuardrailError>,
    Options<DeleteDeterministicGuardrailData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await deleteDeterministicGuardrail({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getDeterministicGuardrailQueryKey = (
  options?: Options<GetDeterministicGuardrailData>
) => [createQueryKey('getDeterministicGuardrail', options)]

export const getDeterministicGuardrailOptions = (
  options?: Options<GetDeterministicGuardrailData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDeterministicGuardrail({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getDeterministicGuardrailQueryKey(options),
  })
}

export const updateDeterministicGuardrailMutation = (
  options?: Partial<Options<UpdateDeterministicGuardrailData>>
) => {
  const mutationOptions: UseMutationOptions<
    UpdateDeterministicGuardrailResponse,
    AxiosError<UpdateDeterministicGuardrailError>,
    Options<UpdateDeterministicGuardrailData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await updateDeterministicGuardrail({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const patchDeterministicGuardrailFallbackPriorityMutation = (
  options?: Partial<Options<PatchDeterministicGuardrailFallbackPriorityData>>
) => {
  const mutationOptions: UseMutationOptions<
    PatchDeterministicGuardrailFallbackPriorityResponse,
    AxiosError<PatchDeterministicGuardrailFallbackPriorityError>,
    Options<PatchDeterministicGuardrailFallbackPriorityData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await patchDeterministicGuardrailFallbackPriority({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const listAiGuidanceQueryKey = (options?: Options<ListAiGuidanceData>) => [
  createQueryKey('listAiGuidance', options),
]

export const listAiGuidanceOptions = (options?: Options<ListAiGuidanceData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listAiGuidance({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listAiGuidanceQueryKey(options),
  })
}

export const listAiGuidanceInfiniteQueryKey = (
  options?: Options<ListAiGuidanceData>
): QueryKey<Options<ListAiGuidanceData>> => [createQueryKey('listAiGuidance', options, true)]

export const listAiGuidanceInfiniteOptions = (options?: Options<ListAiGuidanceData>) => {
  return infiniteQueryOptions<
    ListAiGuidanceResponse,
    AxiosError<ListAiGuidanceError>,
    InfiniteData<ListAiGuidanceResponse>,
    QueryKey<Options<ListAiGuidanceData>>,
    number | Pick<QueryKey<Options<ListAiGuidanceData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListAiGuidanceData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await listAiGuidance({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: listAiGuidanceInfiniteQueryKey(options),
    }
  )
}

export const createAiGuidanceQueryKey = (options: Options<CreateAiGuidanceData>) => [
  createQueryKey('createAiGuidance', options),
]

export const createAiGuidanceOptions = (options: Options<CreateAiGuidanceData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await createAiGuidance({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: createAiGuidanceQueryKey(options),
  })
}

export const createAiGuidanceMutation = (options?: Partial<Options<CreateAiGuidanceData>>) => {
  const mutationOptions: UseMutationOptions<
    CreateAiGuidanceResponse,
    AxiosError<CreateAiGuidanceError>,
    Options<CreateAiGuidanceData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await createAiGuidance({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const deleteAiGuidanceMutation = (options?: Partial<Options<DeleteAiGuidanceData>>) => {
  const mutationOptions: UseMutationOptions<
    DeleteAiGuidanceResponse,
    AxiosError<DeleteAiGuidanceError>,
    Options<DeleteAiGuidanceData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await deleteAiGuidance({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getAiGuidanceQueryKey = (options?: Options<GetAiGuidanceData>) => [
  createQueryKey('getAiGuidance', options),
]

export const getAiGuidanceOptions = (options?: Options<GetAiGuidanceData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAiGuidance({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getAiGuidanceQueryKey(options),
  })
}

export const editDraftGuidanceMutation = (options?: Partial<Options<EditDraftGuidanceData>>) => {
  const mutationOptions: UseMutationOptions<
    EditDraftGuidanceResponse,
    AxiosError<EditDraftGuidanceError>,
    Options<EditDraftGuidanceData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await editDraftGuidance({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const editGuidanceMutation = (options?: Partial<Options<EditGuidanceData>>) => {
  const mutationOptions: UseMutationOptions<
    EditGuidanceResponse,
    AxiosError<EditGuidanceError>,
    Options<EditGuidanceData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await editGuidance({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const publishGuidanceMutation = (options?: Partial<Options<PublishGuidanceData>>) => {
  const mutationOptions: UseMutationOptions<
    PublishGuidanceResponse,
    AxiosError<PublishGuidanceError>,
    Options<PublishGuidanceData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await publishGuidance({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const createDeterministicEvalQueryKey = (options: Options<CreateDeterministicEvalData>) => [
  createQueryKey('createDeterministicEval', options),
]

export const createDeterministicEvalOptions = (options: Options<CreateDeterministicEvalData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await createDeterministicEval({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: createDeterministicEvalQueryKey(options),
  })
}

export const createDeterministicEvalMutation = (
  options?: Partial<Options<CreateDeterministicEvalData>>
) => {
  const mutationOptions: UseMutationOptions<
    CreateDeterministicEvalResponse,
    AxiosError<CreateDeterministicEvalError>,
    Options<CreateDeterministicEvalData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await createDeterministicEval({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const deleteDeterministicEvalMutation = (
  options?: Partial<Options<DeleteDeterministicEvalData>>
) => {
  const mutationOptions: UseMutationOptions<
    DeleteDeterministicEvalResponse,
    AxiosError<DeleteDeterministicEvalError>,
    Options<DeleteDeterministicEvalData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await deleteDeterministicEval({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getDeterministicEvalQueryKey = (options?: Options<GetDeterministicEvalData>) => [
  createQueryKey('getDeterministicEval', options),
]

export const getDeterministicEvalOptions = (options?: Options<GetDeterministicEvalData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDeterministicEval({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getDeterministicEvalQueryKey(options),
  })
}

export const updateDeterministicEvalMutation = (
  options?: Partial<Options<UpdateDeterministicEvalData>>
) => {
  const mutationOptions: UseMutationOptions<
    UpdateDeterministicEvalResponse,
    AxiosError<UpdateDeterministicEvalError>,
    Options<UpdateDeterministicEvalData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await updateDeterministicEval({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const patchDeterministicEvalFallbackPriorityMutation = (
  options?: Partial<Options<PatchDeterministicEvalFallbackPriorityData>>
) => {
  const mutationOptions: UseMutationOptions<
    PatchDeterministicEvalFallbackPriorityResponse,
    AxiosError<PatchDeterministicEvalFallbackPriorityError>,
    Options<PatchDeterministicEvalFallbackPriorityData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await patchDeterministicEvalFallbackPriority({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const listExpertAnswersQueryKey = (options?: Options<ListExpertAnswersData>) => [
  createQueryKey('listExpertAnswers', options),
]

export const listExpertAnswersOptions = (options?: Options<ListExpertAnswersData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listExpertAnswers({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listExpertAnswersQueryKey(options),
  })
}

export const listExpertAnswersInfiniteQueryKey = (
  options?: Options<ListExpertAnswersData>
): QueryKey<Options<ListExpertAnswersData>> => [createQueryKey('listExpertAnswers', options, true)]

export const listExpertAnswersInfiniteOptions = (options?: Options<ListExpertAnswersData>) => {
  return infiniteQueryOptions<
    ListExpertAnswersResponse,
    AxiosError<ListExpertAnswersError>,
    InfiniteData<ListExpertAnswersResponse>,
    QueryKey<Options<ListExpertAnswersData>>,
    | number
    | Pick<QueryKey<Options<ListExpertAnswersData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListExpertAnswersData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await listExpertAnswers({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: listExpertAnswersInfiniteQueryKey(options),
    }
  )
}

export const createExpertAnswerQueryKey = (options: Options<CreateExpertAnswerData>) => [
  createQueryKey('createExpertAnswer', options),
]

export const createExpertAnswerOptions = (options: Options<CreateExpertAnswerData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await createExpertAnswer({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: createExpertAnswerQueryKey(options),
  })
}

export const createExpertAnswerMutation = (options?: Partial<Options<CreateExpertAnswerData>>) => {
  const mutationOptions: UseMutationOptions<
    CreateExpertAnswerResponse,
    AxiosError<CreateExpertAnswerError>,
    Options<CreateExpertAnswerData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await createExpertAnswer({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const deleteExpertAnswerMutation = (options?: Partial<Options<DeleteExpertAnswerData>>) => {
  const mutationOptions: UseMutationOptions<
    DeleteExpertAnswerResponse,
    AxiosError<DeleteExpertAnswerError>,
    Options<DeleteExpertAnswerData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await deleteExpertAnswer({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getExpertAnswerQueryKey = (options?: Options<GetExpertAnswerData>) => [
  createQueryKey('getExpertAnswer', options),
]

export const getExpertAnswerOptions = (options?: Options<GetExpertAnswerData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getExpertAnswer({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getExpertAnswerQueryKey(options),
  })
}

export const getExpertAnswerWithResolvedLogsCountQueryKey = (
  options?: Options<GetExpertAnswerWithResolvedLogsCountData>
) => [createQueryKey('getExpertAnswerWithResolvedLogsCount', options)]

export const getExpertAnswerWithResolvedLogsCountOptions = (
  options?: Options<GetExpertAnswerWithResolvedLogsCountData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getExpertAnswerWithResolvedLogsCount({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getExpertAnswerWithResolvedLogsCountQueryKey(options),
  })
}

export const editDraftExpertAnswerMutation = (
  options?: Partial<Options<EditDraftExpertAnswerData>>
) => {
  const mutationOptions: UseMutationOptions<
    EditDraftExpertAnswerResponse,
    AxiosError<EditDraftExpertAnswerError>,
    Options<EditDraftExpertAnswerData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await editDraftExpertAnswer({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const editExpertAnswerMutation = (options?: Partial<Options<EditExpertAnswerData>>) => {
  const mutationOptions: UseMutationOptions<
    EditExpertAnswerResponse,
    AxiosError<EditExpertAnswerError>,
    Options<EditExpertAnswerData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await editExpertAnswer({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const publishExpertAnswerMutation = (
  options?: Partial<Options<PublishExpertAnswerData>>
) => {
  const mutationOptions: UseMutationOptions<
    PublishExpertAnswerResponse,
    AxiosError<PublishExpertAnswerError>,
    Options<PublishExpertAnswerData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await publishExpertAnswer({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const pauseExpertAnswerMutation = (options?: Partial<Options<PauseExpertAnswerData>>) => {
  const mutationOptions: UseMutationOptions<
    PauseExpertAnswerResponse,
    AxiosError<PauseExpertAnswerError>,
    Options<PauseExpertAnswerData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await pauseExpertAnswer({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const unpauseExpertAnswerMutation = (
  options?: Partial<Options<UnpauseExpertAnswerData>>
) => {
  const mutationOptions: UseMutationOptions<
    UnpauseExpertAnswerResponse,
    AxiosError<UnpauseExpertAnswerError>,
    Options<UnpauseExpertAnswerData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await unpauseExpertAnswer({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const listAppliedToLogsQueryKey = (options?: Options<ListAppliedToLogsData>) => [
  createQueryKey('listAppliedToLogs', options),
]

export const listAppliedToLogsOptions = (options?: Options<ListAppliedToLogsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listAppliedToLogs({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listAppliedToLogsQueryKey(options),
  })
}

export const listAppliedToLogsInfiniteQueryKey = (
  options?: Options<ListAppliedToLogsData>
): QueryKey<Options<ListAppliedToLogsData>> => [createQueryKey('listAppliedToLogs', options, true)]

export const listAppliedToLogsInfiniteOptions = (options?: Options<ListAppliedToLogsData>) => {
  return infiniteQueryOptions<
    ListAppliedToLogsResponse,
    AxiosError<ListAppliedToLogsError>,
    InfiniteData<ListAppliedToLogsResponse>,
    QueryKey<Options<ListAppliedToLogsData>>,
    | number
    | Pick<QueryKey<Options<ListAppliedToLogsData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListAppliedToLogsData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await listAppliedToLogs({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: listAppliedToLogsInfiniteQueryKey(options),
    }
  )
}

export const listIssuesQueryKey = (options?: Options<ListIssuesData>) => [
  createQueryKey('listIssues', options),
]

export const listIssuesOptions = (options?: Options<ListIssuesData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listIssues({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listIssuesQueryKey(options),
  })
}

export const listIssuesInfiniteQueryKey = (
  options?: Options<ListIssuesData>
): QueryKey<Options<ListIssuesData>> => [createQueryKey('listIssues', options, true)]

export const listIssuesInfiniteOptions = (options?: Options<ListIssuesData>) => {
  return infiniteQueryOptions<
    ListIssuesResponse,
    AxiosError<ListIssuesError>,
    InfiniteData<ListIssuesResponse>,
    QueryKey<Options<ListIssuesData>>,
    number | Pick<QueryKey<Options<ListIssuesData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListIssuesData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await listIssues({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: listIssuesInfiniteQueryKey(options),
    }
  )
}

export const listLogsByIssueQueryKey = (options?: Options<ListLogsByIssueData>) => [
  createQueryKey('listLogsByIssue', options),
]

export const listLogsByIssueOptions = (options?: Options<ListLogsByIssueData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listLogsByIssue({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listLogsByIssueQueryKey(options),
  })
}

export const listLogsByIssueInfiniteQueryKey = (
  options?: Options<ListLogsByIssueData>
): QueryKey<Options<ListLogsByIssueData>> => [createQueryKey('listLogsByIssue', options, true)]

export const listLogsByIssueInfiniteOptions = (options?: Options<ListLogsByIssueData>) => {
  return infiniteQueryOptions<
    ListLogsByIssueResponse,
    AxiosError<ListLogsByIssueError>,
    InfiniteData<ListLogsByIssueResponse>,
    QueryKey<Options<ListLogsByIssueData>>,
    number | Pick<QueryKey<Options<ListLogsByIssueData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListLogsByIssueData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await listLogsByIssue({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: listLogsByIssueInfiniteQueryKey(options),
    }
  )
}

export const updateIssueReviewStatusMutation = (
  options?: Partial<Options<UpdateIssueReviewStatusData>>
) => {
  const mutationOptions: UseMutationOptions<
    UpdateIssueReviewStatusResponse,
    AxiosError<UpdateIssueReviewStatusError>,
    Options<UpdateIssueReviewStatusData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await updateIssueReviewStatus({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const tlmHealthCheckQueryKey = (options?: Options<TlmHealthCheckData>) => [
  createQueryKey('tlmHealthCheck', options),
]

export const tlmHealthCheckOptions = (options?: Options<TlmHealthCheckData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await tlmHealthCheck({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: tlmHealthCheckQueryKey(options),
  })
}

export const tlmChatQueryKey = (options?: Options<TlmChatData>) => [
  createQueryKey('tlmChat', options),
]

export const tlmChatOptions = (options?: Options<TlmChatData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await tlmChat({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: tlmChatQueryKey(options),
  })
}

export const listExpertReviewsQueryKey = (options?: Options<ListExpertReviewsData>) => [
  createQueryKey('listExpertReviews', options),
]

export const listExpertReviewsOptions = (options?: Options<ListExpertReviewsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listExpertReviews({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listExpertReviewsQueryKey(options),
  })
}

export const listExpertReviewsInfiniteQueryKey = (
  options?: Options<ListExpertReviewsData>
): QueryKey<Options<ListExpertReviewsData>> => [createQueryKey('listExpertReviews', options, true)]

export const listExpertReviewsInfiniteOptions = (options?: Options<ListExpertReviewsData>) => {
  return infiniteQueryOptions<
    ListExpertReviewsResponse,
    AxiosError<ListExpertReviewsError>,
    InfiniteData<ListExpertReviewsResponse>,
    QueryKey<Options<ListExpertReviewsData>>,
    | number
    | Pick<QueryKey<Options<ListExpertReviewsData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListExpertReviewsData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await listExpertReviews({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: listExpertReviewsInfiniteQueryKey(options),
    }
  )
}

export const createExpertReviewQueryKey = (options: Options<CreateExpertReviewData>) => [
  createQueryKey('createExpertReview', options),
]

export const createExpertReviewOptions = (options: Options<CreateExpertReviewData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await createExpertReview({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: createExpertReviewQueryKey(options),
  })
}

export const createExpertReviewMutation = (options?: Partial<Options<CreateExpertReviewData>>) => {
  const mutationOptions: UseMutationOptions<
    CreateExpertReviewResponse,
    AxiosError<CreateExpertReviewError>,
    Options<CreateExpertReviewData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await createExpertReview({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const deleteExpertReviewMutation = (options?: Partial<Options<DeleteExpertReviewData>>) => {
  const mutationOptions: UseMutationOptions<
    DeleteExpertReviewResponse,
    AxiosError<DeleteExpertReviewError>,
    Options<DeleteExpertReviewData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await deleteExpertReview({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getExpertReviewQueryKey = (options?: Options<GetExpertReviewData>) => [
  createQueryKey('getExpertReview', options),
]

export const getExpertReviewOptions = (options?: Options<GetExpertReviewData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getExpertReview({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getExpertReviewQueryKey(options),
  })
}

export const updateExpertReviewMutation = (options?: Partial<Options<UpdateExpertReviewData>>) => {
  const mutationOptions: UseMutationOptions<
    UpdateExpertReviewResponse,
    AxiosError<UpdateExpertReviewError>,
    Options<UpdateExpertReviewData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await updateExpertReview({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const listExpertReviewAppliedToLogsQueryKey = (
  options?: Options<ListExpertReviewAppliedToLogsData>
) => [createQueryKey('listExpertReviewAppliedToLogs', options)]

export const listExpertReviewAppliedToLogsOptions = (
  options?: Options<ListExpertReviewAppliedToLogsData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listExpertReviewAppliedToLogs({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listExpertReviewAppliedToLogsQueryKey(options),
  })
}

export const listExpertReviewAppliedToLogsInfiniteQueryKey = (
  options?: Options<ListExpertReviewAppliedToLogsData>
): QueryKey<Options<ListExpertReviewAppliedToLogsData>> => [
  createQueryKey('listExpertReviewAppliedToLogs', options, true),
]

export const listExpertReviewAppliedToLogsInfiniteOptions = (
  options?: Options<ListExpertReviewAppliedToLogsData>
) => {
  return infiniteQueryOptions<
    ListExpertReviewAppliedToLogsResponse,
    AxiosError<ListExpertReviewAppliedToLogsError>,
    InfiniteData<ListExpertReviewAppliedToLogsResponse>,
    QueryKey<Options<ListExpertReviewAppliedToLogsData>>,
    | number
    | Pick<
        QueryKey<Options<ListExpertReviewAppliedToLogsData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListExpertReviewAppliedToLogsData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await listExpertReviewAppliedToLogs({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: listExpertReviewAppliedToLogsInfiniteQueryKey(options),
    }
  )
}

export const getMetricsQueryKey = (options?: Options<GetMetricsData>) => [
  createQueryKey('getMetrics', options),
]

export const getMetricsOptions = (options?: Options<GetMetricsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getMetrics({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getMetricsQueryKey(options),
  })
}
